export default __webpack_public_path__ + "static/media/photo-background.f9b6076e.svg";